import { State } from "../types/store";

export const selectUI = (state: State) => state.ui;
export const selectUIAuthPopUpRender = (state: State) => state.ui.authPopUpRender;
export const selectUISettings = (state: State) => state.ui.settings;
export const selectUICollaboration = (state: State) => state.ui.collaboration;
export const selectUIUserOptions = (state: State) => state.ui.userOptions;
export const selectUIPopup = (state: State) => state.ui.currentPopup;
export const selectUICurrentLoginPopupState = (state: State) => state.ui.currentLoginPopupState;
export const selectUICurrentField = (state: State) => state.ui.currentField;
export const selectUICurrentInputEditing = (state: State) => state.ui.currentInputEditing;
export const selectUISideBar = (state: State) => state.ui.sideBar;
export const selectIsVerticalView = (state: State) => state.ui.isVerticalView;
export const selectFormBackground = (state: State) => state.ui.formBackground;
export const selectPaginationActiveStatus = (state: State) => state.ui.isPaginationActive;
export const selectLogicPopup = (state: State) => state.ui.logicPopup;
export const selectMapScriptStatus = (state: State) => state.ui.mapScriptStatus;
export const selectViewMode = (state: State) => state.ui.viewMode;
